// Enumerates what modal screens we might be showing on top of the chat view
export enum Modal {
  None = 0,
  ProfileEdit,
  NoteWall,
  Settings,
  MediaSelector,
  CodeOfConduct,
  Schedule,
  Help,
  Map,
  Welcome,
  RoomList,
  FeatureRainbowGate,
  FeatureDullDoor,
  ServerSettings,
  ClientDeployed,
  Disconnected,
  FeatureFullRoomIndex,
  HappeningNow,
  Riddles,
  Badges,
  BadgeUnlock,
  SpecialFeatureText,
  Obelisk
}
